import { jsx as _jsx } from "react/jsx-runtime";
const GradientBackground = () => (_jsx("div", { className: "fixed top-0 left-0 z-[-2] h-full w-full bg-gradient-to-t from-white to-gray dark:hidden dark:bg-none" }));
export default GradientBackground;
//# sourceMappingURL=GradientBackground.js.map